import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SingleValue } from 'react-select';

import type { IdAccountTypeDto } from '@/services/ws-crm/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Filter } from '@/js/libs/ui/src/V2';

import type { Option } from 'src/types';
import { useAccountTypesOptions } from '../hooks/useAccountTypesOptions';

interface AccountTypeFilterProps {
  value: Option<IdAccountTypeDto> | null;
  onChange: (value: SingleValue<Option<IdAccountTypeDto>>) => void;
  label?: string;
}

export const AccountTypeFilter: React.FC<AccountTypeFilterProps> = React.memo(function AccountTypeFilter({ value, onChange, label }) {
  const [t] = useTranslation(['backend', 'common']);
  const { options, pending: loading } = useAccountTypesOptions();

  const handleChange = useCallbackRef((newValue: SingleValue<Option<IdAccountTypeDto>>) => {
    onChange(newValue);
  });

  return (
    <Filter<IdAccountTypeDto>
      label={label || t('common:CUSTOM_ACCOUNT_TYPE')}
      loading={loading}
      selected={value}
      onChange={handleChange}
      options={options}
      dataTestId='account-type-dropdown'
    />
  );
});
